import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api, storageUrl } from "../api";
import { formatPrice } from "../data/currency";

function DeveloperDashboard() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/developer/dashboard")
      .then(setDashboard)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="dev-dashboard">
      <div className="dev-loading">
        <div className="dev-spinner" />
        <p>Loading your dashboard...</p>
      </div>
    </div>
  );

  if (!dashboard) return (
    <div className="dev-dashboard">
      <div className="dev-loading">
        <p>Failed to load dashboard.</p>
        <button className="dev-retry-btn" onClick={() => window.location.reload()}>Retry</button>
      </div>
    </div>
  );

  return (
    <div className="dev-dashboard">
      <div className="dev-header">
        <div>
          <h2>Developer Dashboard</h2>
          <p className="dev-header-sub">Manage your games and track performance</p>
        </div>
        <Link to="/developer/submit" className="dev-submit-btn">+ Submit New Game</Link>
      </div>

      <div className="dev-stats">
        <div className="dev-stat-card">
          <div className="dev-stat-icon dev-stat-icon-games">G</div>
          <div className="dev-stat-body">
            <span className="dev-stat-value">{dashboard.games_count}</span>
            <span className="dev-stat-label">Total Games</span>
          </div>
        </div>
        <div className="dev-stat-card">
          <div className="dev-stat-icon dev-stat-icon-sales">S</div>
          <div className="dev-stat-body">
            <span className="dev-stat-value">{dashboard.total_sales}</span>
            <span className="dev-stat-label">Total Sales</span>
          </div>
        </div>
        <div className="dev-stat-card">
          <div className="dev-stat-icon dev-stat-icon-revenue">R</div>
          <div className="dev-stat-body">
            <span className="dev-stat-value">{formatPrice(dashboard.total_revenue)}</span>
            <span className="dev-stat-label">Total Revenue</span>
          </div>
        </div>
      </div>

      <div className="dev-games-section">
        <div className="dev-games-header">
          <h3>Your Games</h3>
          <span className="dev-games-count">{dashboard.games.length} game{dashboard.games.length !== 1 ? "s" : ""}</span>
        </div>

        {dashboard.games.length === 0 ? (
          <div className="dev-empty">
            <p>You haven't submitted any games yet.</p>
            <Link to="/developer/submit" className="dev-submit-btn">Submit Your First Game</Link>
          </div>
        ) : (
          <div className="dev-game-cards">
            {dashboard.games.map((game) => {
              const cat = game.category;
              const status = game.status || "pending";
              return (
                <div key={game.id} className="dev-game-card">
                  <div className="dev-game-card-img">
                    <img src={storageUrl(game.thumbnail_path)} alt={game.title} />
                    <span className={`dev-game-status dev-game-status-${status}`}>{status}</span>
                  </div>
                  <div className="dev-game-card-body">
                    <h4>{game.title}</h4>
                    <span className="dev-game-card-cat">{cat ? cat.name : "Uncategorized"}</span>
                    <div className="dev-game-card-meta">
                      <span className="game-card-price">{formatPrice(game.price)}</span>
                      <span className="dev-game-versions">{game.versions?.length || 0} version{(game.versions?.length || 0) !== 1 ? "s" : ""}</span>
                    </div>
                    <div className="dev-game-card-actions">
                      <Link to={`/game/${game.id}`} className="dev-game-view-btn">View</Link>
                      <Link to={`/developer/edit/${game.id}`} className="dev-game-edit-btn">Edit</Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default DeveloperDashboard;
